(function() {
    'use strict';

    angular
        .module('app.moviles')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/moviles',
                config: {
                    templateUrl: 'app/moviles/list.html',
                    controller: 'moviles.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-movil/:id?',
                config: {
                    templateUrl: 'app/moviles/edit.html',
                    controller: 'moviles.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
